import { PortCoKeys, TableKeys } from '../types';

export const getPortCoKeys: Record<TableKeys, PortCoKeys> = {
  [TableKeys.BOP_ARR]: PortCoKeys.ARR_BOP,
  [TableKeys.NEW_LOGO_ARR]: PortCoKeys.ARR_NEWLOGO,
  [TableKeys.EXPANSION_ARR]: PortCoKeys.ARR_EXPANSION,
  [TableKeys.GROSS_NEW_ARR]: PortCoKeys.ARR_GROSSNEW,
  [TableKeys.GROSS_CHURN_ARR]: PortCoKeys.ARR_CHURN_GROSS,
  [TableKeys.NET_NEW_ARR]: PortCoKeys.ARR_NETNEW,
  [TableKeys.ENDING_ARR]: PortCoKeys.ARR_EOP,
  [TableKeys.REVENUE]: PortCoKeys.REVENUE_TOTAL,
  [TableKeys.ANNUALIZED_REVENUE]: PortCoKeys.ANNUALIZED_REVENUE,
  [TableKeys.TOTAL_GROSS_PROFIT]: PortCoKeys.GROSSPROFIT_TOTAL,
  [TableKeys.GROSS_PROFIT_MARGIN]: PortCoKeys.MARGIN_GROSSPROFIT,
  [TableKeys.TOTAL_OPEX_SM]: PortCoKeys.OPEX_SM,
  [TableKeys.TOTAL_OPEX_RD]: PortCoKeys.OPEX_RD,
  [TableKeys.TOTAL_OPEX_GA]: PortCoKeys.OPEX_GA,
  [TableKeys.TOTAL_OPEX]: PortCoKeys.OPEX_TOTAL,
  [TableKeys.FCF]: PortCoKeys.FCF,
  [TableKeys.FCF_MARGIN]: PortCoKeys.MARGIN_FCF,
  [TableKeys.TOTAL_CUSTOMERS]: PortCoKeys.CUSTOMERS_EOP,
  [TableKeys.GROSS_NEW_CUSTOMERS_IN_PERIOD]: PortCoKeys.CUSTOMERS_GROSSNEW,
  [TableKeys.ARR_PER_CUSTOMER]: PortCoKeys.ARR_PER_CUSTOMER,
  [TableKeys.TOTAL_HEADCOUNT_SM]: PortCoKeys.EMPLOYEES_SM,
  [TableKeys.TOTAL_HEADCOUNT_RD]: PortCoKeys.EMPLOYEES_RD,
  [TableKeys.TOTAL_HEADCOUNT_GA]: PortCoKeys.EMPLOYEES_GA,
  [TableKeys.TOTAL_HEADCOUNT]: PortCoKeys.EMPLOYEES_TOTAL,
  [TableKeys.TOTAL_HEADCOUNT_OTHER]: PortCoKeys.EMPLOYEES_OTHER,
  [TableKeys.YOY_ARR_GROWTH]: PortCoKeys.YOY_ARR_GROWTH,
  [TableKeys.COMPOSITION_NEW_LOGO]: PortCoKeys.ARR_PERCTOTAL_GROSSNEW_NEWLOGO,
  [TableKeys.COMPOSITION_EXPANSION]:
    PortCoKeys.ARR_PERCTOTAL_GROSSNEW_EXPANSION,
  [TableKeys.NEW_LOGO_VELOCITY]: PortCoKeys.NEW_LOGO_VELOCITY,
  [TableKeys.QUICK_RATIO]: PortCoKeys.QUICK_RATIO_ARR,
  [TableKeys.GROSS_DOLLAR_RETENTION]: PortCoKeys.RETENTION_GROSS_ARR_ANNUALIZED,
  [TableKeys.NET_DOLLAR_RETENTION]: PortCoKeys.RETENTION_NET_ARR_ANNUALIZED,
  [TableKeys.NET_MAGIC_NUMBER]: PortCoKeys.MAGICNUMBER_NET,
  [TableKeys.RULE_OF_40]: PortCoKeys.RULE_OF_40,
  [TableKeys.CAC]: PortCoKeys.CAC,
  [TableKeys.CAC_PAYBACK_PERIOD]: PortCoKeys.CAC_PAYBACK,
  [TableKeys.BURN_MULTIPLE]: PortCoKeys.BURN_MULTIPLE,
  [TableKeys.PERC_OPEX_SM]: PortCoKeys.MARGIN_OPEX_SM,
  [TableKeys.PERC_OPEX_RD]: PortCoKeys.MARGIN_OPEX_RD,
  [TableKeys.PERC_OPEX_GA]: PortCoKeys.MARGIN_OPEX_GA,
  [TableKeys.GROSS_PROFIT_MARGIN_1]: PortCoKeys['MARGIN_GROSSPROFIT.1'],
  [TableKeys.FCF_MARGIN_1]: PortCoKeys['MARGIN_FCF.1'],
  [TableKeys.ARR_PER_FTE]: PortCoKeys.ARR_PER_FTE,
  [TableKeys.OPEX_PER_FTE]: PortCoKeys.OPEX_PER_FTE,
  [TableKeys.PERC_HEADCOUNT_SM]: PortCoKeys.EMPLOYEES_PERCTOTAL_SM,
  [TableKeys.PERC_HEADCOUNT_RD]: PortCoKeys.EMPLOYEES_PERCTOTAL_RD,
  [TableKeys.PERC_HEADCOUNT_GA]: PortCoKeys.EMPLOYEES_PERCTOTAL_GA,
  [TableKeys.PERC_HEADCOUNT_OTHER]: PortCoKeys.EMPLOYEES_PERCTOTAL_OTHER
};
